var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 2.33398H2.33317C1.89114 2.33398 1.46722 2.50958 1.15466 2.82214C0.842099 3.1347 0.666504 3.55862 0.666504 4.00065V15.6673C0.666504 16.1093 0.842099 16.5333 1.15466 16.8458C1.46722 17.1584 1.89114 17.334 2.33317 17.334H13.9998C14.4419 17.334 14.8658 17.1584 15.1783 16.8458C15.4909 16.5333 15.6665 16.1093 15.6665 15.6673V9.83399",
    stroke: "#1E2228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4165 1.08417C14.748 0.752653 15.1977 0.566406 15.6665 0.566406C16.1353 0.566406 16.585 0.752653 16.9165 1.08417C17.248 1.41569 17.4343 1.86533 17.4343 2.33417C17.4343 2.80301 17.248 3.25265 16.9165 3.58417L8.99984 11.5008L5.6665 12.3342L6.49984 9.00084L14.4165 1.08417Z",
    stroke: "#1E2228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.00d44c9beadb900137d585162a2c192e.svg";
export { ForwardRef as ReactComponent };